import { downloadExternalPrintForm, type PrintFormDocumentType } from "helpers/printForms";
import { useRef, useState } from "react";

interface ExternalPrintFormDownloadOptions {
    documentType: PrintFormDocumentType;
    requestFn: (documentId: number) => Promise<Response>;
}

/** Keep this hook above any UI that unmounts when a document section is collapsed. */
export const useExternalPrintFormDownload = ({ documentType, requestFn }: ExternalPrintFormDownloadOptions) => {
    const pendingIds = useRef(new Set<number>());
    const [loadingIds, setLoadingIds] = useState<Set<number>>(new Set());

    const download = async (documentId: number) => {
        if (pendingIds.current.has(documentId)) {
            return;
        }
        pendingIds.current.add(documentId);
        setLoadingIds(new Set(pendingIds.current));
        try {
            await downloadExternalPrintForm({ documentId, documentType, requestFn: () => requestFn(documentId) });
        } finally {
            pendingIds.current.delete(documentId);
            setLoadingIds(new Set(pendingIds.current));
        }
    };

    return { download, isDownloading: (documentId: number) => loadingIds.has(documentId) };
};
